import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { StrapiCustomerCreateData } from '../../api/strapiCrm';
import { strapiCreateCustomer } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useCreateCustomerMutation(jwt: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: StrapiCustomerCreateData) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiCreateCustomer(jwt, data);
    },
    onSuccess: async (_, __) => {
      await qc.invalidateQueries({ queryKey: queryKeys.customersListPrefix(jwt) });
    },
  });
}
